import { render, staticRenderFns } from "./openclassxq.vue?vue&type=template&id=e087c124&scoped=true"
import script from "./openclassxq.vue?vue&type=script&lang=js"
export * from "./openclassxq.vue?vue&type=script&lang=js"
import style0 from "./openclassxq.vue?vue&type=style&index=0&id=e087c124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e087c124",
  null
  
)

export default component.exports